import { ReactNode, useEffect } from 'react';

import classNames from 'classnames';

import WithLoading from '@/lib/hoc/WithLoading/WithLoading';

import styles from './PopUp.module.scss';

interface PopUpProps {
  handleClose: () => void;
  children: ReactNode;
  centered?: boolean;
  isOpen?: boolean;
  isLoading?: boolean;
  maxWidth?: number;
  withClose?: boolean;
  outsideClose?: boolean;
  textAlign?: 'center';
  padding?: number;
  variant?: 'danger' | 'success' | 'warning';
}

const PopUp = ({
  isOpen,
  children,
  handleClose,
  isLoading = false,
  maxWidth,
  centered = true,
  outsideClose = true,
  withClose = true,
  textAlign,
  padding,
  variant,
}: PopUpProps) => {
  const handleCloseManually = () => {
    document.body.style.overflow = 'auto';
    handleClose();
  };

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className={styles.background}
      onClick={outsideClose ? handleCloseManually : undefined}
      style={{
        maxWidth,
        alignItems: centered ? 'center' : 'flex-start',
      }}
    >
      <div
        style={{ maxWidth, textAlign, padding }}
        className={classNames(styles.popup, styles[`${variant}-content`])}
        onClick={(e) => e.stopPropagation()}
      >
        <WithLoading isLoading={isLoading}>
          {withClose && (
            <img
              onClick={handleCloseManually}
              className={styles.popup__close}
              src="/icons/close.svg"
              alt="close"
              width={28}
              height={28}
            />
          )}
          {children}
        </WithLoading>
      </div>
    </div>
  );
};

export default PopUp;
